import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";
import ReactMarkdown from 'react-markdown'
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import NoticePeriodCalculatorApp from '../components/NoticePeriodCalculator';


import MarkdownContent from '../content/notice-period.md';
import gfm from 'remark-gfm'
import math from 'remark-math'
import frontmatter from 'remark-frontmatter'

function NoticePeriodCalculator() {

  const [markdown, setMarkdown] = useState(null)

  useEffect(() => {
    fetch(MarkdownContent).then(res => res.text()).then(text => {
      setMarkdown(text)
    });
  },[]);

  return (
    <React.Fragment>
      <Helmet>
          <title>Notice Period Calculator | Buddy</title>
          <meta name="description" content="Payroll software starting from just €200, paid per payslip generated. Discover our pricing." />
          <link rel="canonical" href={`https://www.buddy.hr/mt/notice-period-calculator`} />
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">


          <div className="col-span-10">
            <div className="max-w-7xl mx-auto py-4 px-4 sm:py-4 sm:px-6 lg:px-8 sm:text-center md:text-left lg:flex lg:justify-between">
              <div className="max-w-xl">
                <h2 className="text-4xl font-extrabold text-white sm:text-5xl sm:tracking-tight lg:text-6xl">
                  Notice Period Calculator
                </h2>
                <p className="mt-5 text-xl text-gray-400">
                  Calculate the notice period and related payouts for a Malta based employment using a few key pieces of information.
                </p>
              </div>
            </div>
          </div>
          <NoticePeriodCalculatorApp />
        </div>
      </main>


      
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 space-y-8 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-start">
            <div className="relative z-10">
              <div className="prose prose-orange text-gray-500 mx-auto lg:max-w-none">
                <ReactMarkdown 
                  children={markdown} 
                  remarkPlugins={[gfm,math,[frontmatter, ['yaml','toml']]]}
                />
              </div>
              {/*<div className="mt-10 flex text-base max-w-prose mx-auto lg:max-w-none">
                <div className="rounded-md shadow">
                  <a href="#" className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700">
                    Contact sales
                  </a>
                </div>
                <div className="rounded-md shadow ml-4">
                  <a href="#" className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-orange-600 bg-white hover:bg-gray-50">
                    Learn more
                  </a>
                </div>
              </div>*/}
            </div>
            <div className="mt-12 relative text-base max-w-prose mx-auto lg:mt-0 lg:max-w-none" style={{height: "100%"}}>

              {/* <svg className="absolute top-0 right-0 -mt-12 -mr-20 lg:top-auto lg:right-auto lg:bottom-1/2 lg:left-1/2 lg:mt-0 lg:mr-0 xl:top-0 xl:right-0 xl:-mt-12 xl:-mr-20" width="404" height="384" fill="none" viewBox="0 0 404 384" aria-hidden="true">
                <defs>
                  <pattern id="bedc54bc-7371-44a2-a2bc-dc68d819ae60" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                  </pattern>
                </defs>
                <rect width="404" height="384" fill="url(#bedc54bc-7371-44a2-a2bc-dc68d819ae60)" />
              </svg> */}

              <div className="sticky" style={{top: 10}}>
               
              </div>

            </div>
          </div>
        </div>
      </div>


      <div className="bg-orange-700">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            <span className="block">Say hello to easy payslips.</span>
            <span className="block">Start using Buddy today.</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-orange-200">Buddy has Malta's easiest to understand payslips. <br/>It's super easy to use with no previous experience required.</p>
          <Link to="/" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-orange-600 bg-white hover:bg-orange-50 sm:w-auto">
            Try Buddy for free
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoticePeriodCalculator)